import React, { useEffect, useRef, useState } from 'react'
import className from 'classnames'
import InputMask from "react-input-mask";
import Button from '../Button/Button'
import Datepicker from '../Datepicker/Datepicker'
import { format, isValid, subDays } from 'date-fns'
import { getMaxDate, getMinDate } from '../DateTime/helper'
import { months, validDateRegex, withInRangeSet, getMaskValue } from '../Datepicker/helpers'
import ButtonGroup from '../Button/ButtonGroup/ButtonGroup'
import FieldLabel from '../FieldLabel/FieldLabel'
import ValidationMessage from '../ValidationMessage/ValidationMessage';
import Info from '../Info/Info';
// import './DateRangePicker.css'

const getInitialTimeString = (date: string) => {
  const d = new Date(date)
  try {
    return `${format(d, 'HH:mm:ss')}.${format(d, 'SSS')}`
  } catch {
    return '00:00:00.000'
  }
}

export const DateRangePickerV2: any = (props: any) => {
  const {
    t = (key: string) => '',
    cancelCtaTestId,
    doneCtaTestId,
    onCancel,
    onDone,
    inputMaskTestId,
    inputMaskDisabled,
    placeholder,
    testId,
    minDate,
    maxDate,
    minStartDate,
    maxEndDate,
    startDate,
    endDate,
    classname,
    onChangeCb,
    onSave,
    dateChangeChildren,
    onResetCb,
    customFilterDates,
    dateRangeFilterList,
    selectedDateRangeFilter,
    withFooter = true,
    withFilters = true,
    enableTimePicker = false,
    maxCustomPastDays,
    showCustomDateInfoBanner,
    customDateInfoBannerContent,
    ...rest
  }: any = props
  const getSelectedCalenderFilter = (sDate, eDate) => {
    let filterLabel: any = 'Custom Date'
    if (format(eDate, 'MM-dd-yyyy') !== format(new Date(), 'MM-dd-yyyy')) {
      filterLabel = 'Custom Date'
    } else {
      if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 1)), 'MM-dd-yyyy')) filterLabel = 'Last 1 day';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 6)), 'MM-dd-yyyy')) filterLabel = 'Last 7 days';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 13)), 'MM-dd-yyyy')) filterLabel = 'Last 14 days';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 29)), 'MM-dd-yyyy')) filterLabel = 'Last 30 days';
      else {
        if (customFilterDates?.length > 0) {
          customFilterDates.map((el) => {
            if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), (el - 1))), 'MM-dd-yyyy')) {
              filterLabel = `Last ${el} days`
            }
          })
        }
      }
    }
    return filterLabel
  }
  const [currentCalenderActive, setcurrentCalenderActive] = useState('from')
  const [calenderStartDate, setCalenderStartDate] = useState(enableTimePicker ? new Date(startDate) : new Date(new Date(startDate).setHours(0, 0, 0, 0)))
  const [calenderEndDate, setCalenderEndDate] = useState(enableTimePicker ? new Date(endDate) : new Date(new Date(endDate).setHours(23, 59, 59, 59)))
  const [startDateInputMask, setStartDateInputMask] = useState(format(new Date(startDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
  const [endDateInputMask, setEndDateInputMask] = useState(format(new Date(endDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
  const initialFromTime = getInitialTimeString(startDate)
  const initialToTime = getInitialTimeString(endDate)
  const [fromTimeInputMask, setFromTimeInputMask] = useState(initialFromTime)
  const [toTimeInputMask, setToTimeInputMask] = useState(initialToTime)
  const [fromTimeError, setFromTimeError] = useState('')
  const [toTimeError, setToTimeError] = useState('')
  const [selectedCalenderFilter, setSelectedCalenderFilter] = useState(getSelectedCalenderFilter(startDate, endDate))
  const [rangeHasErrorObject, setRangeHasErrorObject] = useState({
    has_error: false,
    error_message: ''
  })

  const calenderRangeStart = useRef(null);
  const calenderRangeEnd = useRef(null);

  const restrictedMinDate = maxCustomPastDays 
    ? new Date(subDays(new Date(), maxCustomPastDays - 1).setHours(0, 0, 0, 0))
    : undefined;


  const onStartDateInputChangeHandler = (event: any) => {
    if (event.target.value) {
      let dateValue = event.target.value;
      if (dateValue === "mm-dd-yyyy") {
        if (dateValue.replace(/y|m|d/g, '').match(/^[\d-/]+$/)) {
          setRangeHasErrorObject({
            has_error: true,
            error_message: 'Please enter/select end date'
          })
          setStartDateInputMask(dateValue)
        }
      } else if (((dateValue.match(validDateRegex) !== null)) || dateValue === '') {
        const gmtFormat: any = new Date(dateValue) || dateValue
        let updatedDateValue: any = new Date(gmtFormat).getTime() ? format(gmtFormat, 'MM-dd-yyyy') : gmtFormat
        // onChange(updatedDateValue)
        if (rangeHasErrorObject.has_error && endDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
        // hasErrorCB && hasErrorCB(false)
        setStartDateInputMask(dateValue)
        setCalenderStartDate(gmtFormat)
        if (gmtFormat.getTime() > calenderEndDate.getTime()) {
          setCalenderEndDate(gmtFormat)
          setEndDateInputMask(dateValue)
        }
        onChangeCb && onChangeCb([
          {
            startDate: gmtFormat,
            endDate: calenderEndDate,
          }
        ])
        setSelectedCalenderFilter(getSelectedCalenderFilter(gmtFormat, calenderEndDate))

        // Re-validate time fields when date changes and time picker is enabled
        if (enableTimePicker) {
          const baseFromErr = validateTimeField(fromTimeInputMask)
          const baseToErr = validateTimeField(toTimeInputMask)
          const endDateToUse = gmtFormat.getTime() > calenderEndDate.getTime() ? gmtFormat : calenderEndDate
          runCrossTimeValidation(fromTimeInputMask, toTimeInputMask, baseFromErr, baseToErr, 'from', gmtFormat, endDateToUse)
        }

        calenderRangeStart?.current?.setSelected(gmtFormat, event)
        calenderRangeStart?.current?.setPreSelection(gmtFormat)
        if (calenderRangeStart?.current?.calenderView !== "date") calenderRangeStart?.current?.setCalenderView("date")
      } else {
        if (!rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: true, error_message: t('DateRangePicker.please_enter_valid_date') || 'Please enter valid date' })
        // hasErrorCB && hasErrorCB(true)
        setStartDateInputMask(dateValue)
      }
    }
  }

  const onEndDateInputChangeHandler = (event: any) => {
    if (event.target.value) {
      let dateValue = event.target.value;
      if (dateValue === "mm-dd-yyyy") {
        if (dateValue.replace(/y|m|d/g, '').match(/^[\d-/]+$/)) {
          setRangeHasErrorObject({
            has_error: true,
            error_message: t('DateRangePicker.please_enter_select_end_date') || 'Please enter/select end date'
          })
          setEndDateInputMask(dateValue)
        }
      } else if (((dateValue.match(validDateRegex) !== null)) || dateValue === '') {
        const gmtFormat: any = new Date(dateValue) || dateValue
        if (gmtFormat.getTime() < calenderStartDate.getTime()) {
          setEndDateInputMask(dateValue)
          setRangeHasErrorObject({
            has_error: true,
            error_message: t('DateRangePicker.end_date_cannot_be_less_than_start_date') || 'End date cannot be less than start date'
          })
        } else {
          let updatedDateValue: any = new Date(gmtFormat).getTime() ? format(gmtFormat, 'MM-dd-yyyy') : gmtFormat
          // onChange(updatedDateValue)
          if (rangeHasErrorObject.has_error && startDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
          // hasErrorCB && hasErrorCB(false)
          setEndDateInputMask(dateValue)
          setCalenderEndDate(gmtFormat)
          onChangeCb && onChangeCb([
            {
              startDate: calenderStartDate,
              endDate: gmtFormat,
            }
          ])
          setSelectedCalenderFilter(getSelectedCalenderFilter(calenderStartDate, gmtFormat))

          // Re-validate time fields when date changes and time picker is enabled
          if (enableTimePicker) {
            const baseFromErr = validateTimeField(fromTimeInputMask)
            const baseToErr = validateTimeField(toTimeInputMask)
            runCrossTimeValidation(fromTimeInputMask, toTimeInputMask, baseFromErr, baseToErr, 'to', calenderStartDate, gmtFormat)
          }

          calenderRangeEnd?.current?.setSelected(gmtFormat, event)
          calenderRangeEnd?.current?.setPreSelection(gmtFormat)
        }
        if (calenderRangeEnd?.current?.calenderView !== "date") calenderRangeEnd?.current?.setCalenderView("date")
      } else {
        if (!rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: true, error_message: t('DateRangePicker.please_enter_valid_date') || 'Please enter valid date' })
        // hasErrorCB && hasErrorCB(true)
        setEndDateInputMask(dateValue)
      }
    }
  }

  const onFromTimeInputChangeHandler = (event: any) => {
    const next = sanitizeTimeValue(event?.target?.value || '')
    setFromTimeInputMask(next)
    if (enableTimePicker) {
      const baseFromErr = validateTimeField(next)
      const baseToErr = validateTimeField(toTimeInputMask)
      runCrossTimeValidation(next, toTimeInputMask, baseFromErr, baseToErr, 'from')
    }
  }

  const onToTimeInputChangeHandler = (event: any) => {
    const next = sanitizeTimeValue(event?.target?.value || '')
    setToTimeInputMask(next)
    if (enableTimePicker) {
      const baseFromErr = validateTimeField(fromTimeInputMask)
      const baseToErr = validateTimeField(next)
      runCrossTimeValidation(fromTimeInputMask, next, baseFromErr, baseToErr, 'to')
    }
  }

  const sanitizeTimeValue = (value: string) => {
    if (!value) return ''
    // Replace any whitespace with 0 and trim
    return value.replace(/\s/g, '0')
  }

  const getTimeParts = (value: string) => {
    const normalized = sanitizeTimeValue(value || '')
    const parts = normalized.split(':')
    const hh = parts[0] || ''
    const mm = parts[1] || ''
    const ssAndMs = (parts[2] || '').split('.')
    const ss = ssAndMs[0] || ''
    const ms = (ssAndMs[1] || '000')
    const complete = (hh.length === 2 && mm.length === 2 && ss.length === 2 && ms.length === 3)
    return { hh, mm, ss, ms, complete }
  }

  const validateSegment = (seg: string, min: number, max: number, label: string) => {
    if (seg.length < 2) return ''
    const num = parseInt(seg, 10)
    if (Number.isNaN(num) || num < min || num > max) {
      if (label === 'Hours') return t('DateRangePicker.invalid_hours') || 'Invalid hours'
      if (label === 'Minutes') return t('DateRangePicker.invalid_minutes') || 'Invalid minutes'
      if (label === 'Seconds') return t('DateRangePicker.invalid_seconds') || 'Invalid seconds'
      return `${label} should be between ${String(min).padStart(2, '0')} and ${String(max).padStart(2, '0')}`
    }
    return ''
  }

  const validateTimeField = (value: string) => {
    const { hh, mm, ss, ms } = getTimeParts(value)
    const baseError = (
      validateSegment(hh, 0, 23, 'Hours') ||
      validateSegment(mm, 0, 59, 'Minutes') ||
      validateSegment(ss, 0, 59, 'Seconds')
    )
    if (baseError) return baseError
    // Special handling for milliseconds - must be exactly 3 digits if present
    if (ms.length > 0 && ms.length < 3) return t('DateRangePicker.milliseconds_should_be_between_000_and_999') || 'Milliseconds should be between 000 and 999'
    if (ms.length === 3) {
      return validateSegment(ms, 0, 999, 'Milliseconds')
    }
    return ''
  }

  const compareTimes = (from: string, to: string) => {
    const a = getTimeParts(from)
    const b = getTimeParts(to)
    if (!a.complete || !b.complete) return ''
    const aNum = Number(`${a.hh}${a.mm}${a.ss}${a.ms.padStart(3, '0')}`)
    const bNum = Number(`${b.hh}${b.mm}${b.ss}${b.ms.padStart(3, '0')}`)
    return aNum <= bNum ? '' : t('DateRangePicker.from_time_must_be_less_than_to_time') || 'From Time must be less than To Time'
  }

  const getTimeComparison = (from: string, to: string) => {
    const a = getTimeParts(from)
    const b = getTimeParts(to)
    if (!a.complete || !b.complete) return null
    const aNum = Number(`${a.hh}${a.mm}${a.ss}${a.ms.padStart(3, '0')}`)
    const bNum = Number(`${b.hh}${b.mm}${b.ss}${b.ms.padStart(3, '0')}`)
    if (aNum < bNum) return -1
    if (aNum === bNum) return 0
    return 1
  }

  const runCrossTimeValidation = (from: string, to: string, baseFromErr: string, baseToErr: string, changed: 'from' | 'to', customStartDate?: Date, customEndDate?: Date) => {
    // Create full datetime objects by combining date and time
    const createDateTimeObject = (baseDate: Date, timeStr: string) => {
      const d = new Date(baseDate)
      const { hh, mm, ss, ms, complete } = getTimeParts(timeStr)
      if (complete) {
        const hoursNum = parseInt(hh || '0', 10) || 0
        const minutesNum = parseInt(mm || '0', 10) || 0
        const secondsNum = parseInt(ss || '0', 10) || 0
        const millisNum = (parseInt((ms || '0').padEnd(3, '0'), 10) || 0)
        d.setHours(hoursNum, minutesNum, secondsNum, millisNum)
      }
      return d
    }

    const startDateToUse = customStartDate || calenderStartDate
    const endDateToUse = customEndDate || calenderEndDate
    const fromDateTime = createDateTimeObject(startDateToUse, from)
    const toDateTime = createDateTimeObject(endDateToUse, to)

    if (changed === 'from') {
      let crossErr = ''
      // Only validate if both times are complete
      const fromParts = getTimeParts(from)
      const toParts = getTimeParts(to)
      if (fromParts.complete && toParts.complete) {
        crossErr = fromDateTime.getTime() >= toDateTime.getTime() && (startDateToUse === endDateToUse) ? t('DateRangePicker.from_time_must_be_less_than_to_time_lowercase') || 'From time must be less than To time' : ''
      }
      setFromTimeError(baseFromErr || crossErr)
      setToTimeError(baseToErr || '')
    } else {
      let crossErr = ''
      // Only validate if both times are complete
      const fromParts = getTimeParts(from)
      const toParts = getTimeParts(to)
      if (fromParts.complete && toParts.complete) {
        crossErr = fromDateTime.getTime() >= toDateTime.getTime() ? t('DateRangePicker.to_time_must_be_greater_than_from_time') || 'To time must be greater than From time' : ''
      }
      setToTimeError(baseToErr || crossErr)
      setFromTimeError(baseFromErr || '')
    }
  }

  useEffect(() => {
    if (enableTimePicker) {
      // Sync time fields from incoming dates when props change
      const fmt = (d: Date) => `${format(d, 'HH:mm:ss')}.${format(d, 'SSS')}`
      if (startDate) setFromTimeInputMask(fmt(new Date(startDate)))
      if (endDate) setToTimeInputMask(fmt(new Date(endDate)))
      setCalenderStartDate(new Date(startDate))
      setCalenderEndDate(new Date(endDate))
      const fErr = validateTimeField(fromTimeInputMask)
      const tErr = validateTimeField(toTimeInputMask)
      runCrossTimeValidation(fromTimeInputMask, toTimeInputMask, fErr, tErr, 'from')
    } else {
      setFromTimeError('')
      setToTimeError('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableTimePicker, startDate, endDate])

  const onStartDateCalenderChangeHandler = (date) => {
    if (calenderEndDate.getTime() < new Date(date.split(' ').join('-')).getTime()) {
      setCalenderEndDate(new Date(date.split(' ').join('-')))
      setEndDateInputMask(date.split(' ').join('-'))
      setSelectedCalenderFilter('Custom Date')
    }
    setCalenderStartDate(new Date(date.split(' ').join('-')))
    setStartDateInputMask(date.split(' ').join('-'))
    onChangeCb && onChangeCb([
      {
        startDate: new Date(date.split(' ').join('-')),
        endDate: calenderEndDate,
      }
    ])
    if (rangeHasErrorObject.has_error && endDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
    setSelectedCalenderFilter(getSelectedCalenderFilter(new Date(date.split(' ').join('-')), calenderEndDate))

    // Re-validate time fields when date changes and time picker is enabled
    if (enableTimePicker) {
      const baseFromErr = validateTimeField(fromTimeInputMask)
      const baseToErr = validateTimeField(toTimeInputMask)
      const newStartDate = new Date(date.split(' ').join('-'))
      const endDateToUse = calenderEndDate.getTime() < newStartDate.getTime() ? newStartDate : calenderEndDate
      runCrossTimeValidation(fromTimeInputMask, toTimeInputMask, baseFromErr, baseToErr, 'from', newStartDate, endDateToUse)
    }

    calenderRangeStart?.current?.calenderViewType === "date" && setcurrentCalenderActive('to')
  }

  const onEndDateCalenderChangeHandler = (date) => {
    setCalenderEndDate(new Date(date.split(' ').join('-')))
    setEndDateInputMask(date.split(' ').join('-'))
    onChangeCb && onChangeCb([
      {
        startDate: calenderStartDate,
        endDate: new Date(date.split(' ').join('-')),
      }
    ])
    if (rangeHasErrorObject.has_error && startDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
    setSelectedCalenderFilter(getSelectedCalenderFilter(calenderStartDate, new Date(date.split(' ').join('-'))))

    // Re-validate time fields when date changes and time picker is enabled
    if (enableTimePicker) {
      const baseFromErr = validateTimeField(fromTimeInputMask)
      const baseToErr = validateTimeField(toTimeInputMask)
      const newEndDate = new Date(date.split(' ').join('-'))
      runCrossTimeValidation(fromTimeInputMask, toTimeInputMask, baseFromErr, baseToErr, 'to', calenderStartDate, newEndDate)
    }
  }

  const onDoneClickHandler = () => {
    const buildDateWithTime = (baseDate: Date, timeStr: string, isEnd: boolean) => {
      const d = new Date(baseDate)
      if (enableTimePicker) {
        const { hh, mm, ss, ms } = getTimeParts(timeStr)
        const hoursNum = parseInt(hh || '0', 10) || 0
        const minutesNum = parseInt(mm || '0', 10) || 0
        const secondsNum = parseInt(ss || '0', 10) || 0
        const millisNum = (parseInt((ms || '0').padEnd(3, '0'), 10) || 0)
        d.setHours(hoursNum, minutesNum, secondsNum, millisNum)
      } else {
        if (isEnd) {
          d.setHours(23, 59, 59, 0)
        } else {
          d.setHours(0, 0, 0, 0)
        }
      }
      return d
    }

    const fromDate = buildDateWithTime(calenderStartDate, fromTimeInputMask, false)
    const toDate = buildDateWithTime(calenderEndDate, toTimeInputMask, true)

    onChangeCb && onChangeCb([{ startDate: fromDate, endDate: toDate }])

    if (onDone) onDone([{ startDate: fromDate, endDate: toDate }])

    if (onSave) onSave([{ startDate: fromDate, endDate: toDate }])
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const onCancelClickHandler = () => {
    if (onCancel) onCancel()
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const onResetClickHandler = (e: any) => {
    if (dateChangeChildren) {
      if (onResetCb) onResetCb()
      if (rest.closeModal) rest.closeModal()
    } else {
      // Reset time fields when enableTimePicker is enabled
      if (enableTimePicker) {
        setFromTimeInputMask('00:00:00.000')
        setToTimeInputMask('23:59:59.000')
        // Clear any time validation errors
        setFromTimeError('')
        setToTimeError('')

        // Create new date objects with reset times
        const resetStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0)
        const resetEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 0)

        // Update local state with reset times
        setCalenderStartDate(resetStartDate)
        setCalenderEndDate(resetEndDate)

        // Update input masks
        setStartDateInputMask(format(new Date(startDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
        setEndDateInputMask(format(new Date(endDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))

        // Communicate reset dates to parent component
        setTimeout(() => {
          onChangeCb && onChangeCb([
            {
              startDate: resetStartDate,
              endDate: resetEndDate
            }
          ])
        }, 0)

        // Update calendar selections
        if (currentCalenderActive === 'from') calenderRangeStart?.current?.setSelected(resetStartDate, e); calenderRangeStart?.current?.setPreSelection(resetStartDate);
        if (currentCalenderActive === 'to') calenderRangeEnd?.current?.setSelected(resetEndDate, e); calenderRangeEnd?.current?.setPreSelection(resetEndDate)
      } else {
        // Original behavior when time picker is disabled
        setCalenderStartDate(startDate)
        setCalenderEndDate(endDate)
        setStartDateInputMask(format(new Date(startDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
        setEndDateInputMask(format(new Date(endDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))

        onChangeCb && onChangeCb([
          {
            startDate: startDate,
            endDate: endDate
          }
        ])

        if (currentCalenderActive === 'from') calenderRangeStart?.current?.setSelected(startDate, e); calenderRangeStart?.current?.setPreSelection(startDate);
        if (currentCalenderActive === 'to') calenderRangeEnd?.current?.setSelected(endDate, e); calenderRangeEnd?.current?.setPreSelection(endDate)
      }

      setSelectedCalenderFilter(getSelectedCalenderFilter(startDate, endDate))
      if (rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: false, error_message: '' })
    }
  }

    const shouldRestrictDates = () => {
      if (selectedCalenderFilter === (t('DateRangePicker.custom_date') || 'Custom Date') || selectedCalenderFilter === (t('DateRangePicker.custom_range') || 'Custom Range')) {
        return maxCustomPastDays ? true : false;
      }
      return 'preset';
    };
  
    // Get the appropriate minDate based on filter type
    const getMinDateForCalendar = (isFromCalendar = false) => {
      const restrictionType = shouldRestrictDates();
      
      if (restrictionType === false) {
        return minDate || undefined;
      } else if (restrictionType === true) {
        return restrictedMinDate || minDate;
      } else {
        return isFromCalendar ? (minDate || undefined) : (minStartDate || calenderStartDate);
      }
    };

  const applyRangeFilter = (sDate, eDate, e, filterName) => {
    setStartDateInputMask(format(new Date(sDate), 'MM-dd-yyyy'))
    setCalenderStartDate(sDate)
    setEndDateInputMask(format(new Date(eDate), 'MM-dd-yyyy'))
    setCalenderEndDate(eDate)
    if (rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: false, error_message: '' })
    if (currentCalenderActive === 'from') calenderRangeStart?.current?.setSelected(sDate, e); calenderRangeStart?.current?.setPreSelection(sDate)
    if (currentCalenderActive === 'to') calenderRangeEnd?.current?.setSelected(eDate, e); calenderRangeEnd?.current?.setPreSelection(eDate)
    setSelectedCalenderFilter(filterName)
    // propagate selection so parent summary updates immediately
    onChangeCb && onChangeCb([
      {
        startDate: sDate,
        endDate: eDate,
      }
    ])
  }

  const maskProp = {
    hasInputMask: false
  }
  const builtInDateRangeFilterList: any = [
    {
      label: t('DateRangePicker.last_1_day') || 'Last 1 day',
      action: (e) => {
        let lte = new Date(subDays(new Date(), 1).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 1 day')
        applyRangeFilter(lte, gte, e, t('DateRangePicker.last_1_day') || 'Last 1 day')
      },
      testId: 'cs-daterange-filter-1'
    },
    {
      label: t('DateRangePicker.last_7_days') || 'Last 7 days',
      action: (e) => {
        let lte = new Date(subDays(new Date(), 6).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 7 days')
        applyRangeFilter(lte, gte, e, t('DateRangePicker.last_7_days') || 'Last 7 days')
      },
      testId: 'cs-daterange-filter-7'
    },
    {
      label: t('DateRangePicker.last_14_days') || 'Last 14 days',
      action: (e) => {
        let lte = new Date(subDays(new Date(), 13).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 14 days')
        applyRangeFilter(lte, gte, e, t('DateRangePicker.last_14_days') || 'Last 14 days')
      },
      testId: 'cs-daterange-filter-14'
    },
    {
      label: t('DateRangePicker.last_30_days') || 'Last 30 days',
      action: (e) => {
        let lte = new Date(subDays(new Date(), 29).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 30 days')
        applyRangeFilter(lte, gte, e, t('DateRangePicker.last_30_days') || 'Last 30 days')
      },
      testId: 'cs-daterange-filter-30'
    },
    {
      label: t('DateRangePicker.custom_date') || 'Custom Date',
      action: () => {
        setSelectedCalenderFilter(t('DateRangePicker.custom_date') || 'Custom Date')
      },
      testId: 'cs-daterange-filter-custom'
    }
  ]
  if (customFilterDates) {
    const lastEl: any = builtInDateRangeFilterList.pop()
    customFilterDates.map((filter_el: any) => {
      builtInDateRangeFilterList.push({
        label: `Last ${filter_el} days`,
        action: (e) => {
          let lte = new Date(subDays(new Date(), filter_el - 1).setHours(0, 0, 0, 0))
          let gte = new Date(new Date().setHours(23, 59, 59, 59))
          // setSelectedCalenderFilter('Last 30 days')
          applyRangeFilter(lte, gte, e, `Last ${filter_el} days`)
        },
        testId: `cs-daterange-filter-${filter_el}`
      })
    })
    builtInDateRangeFilterList.push(lastEl)
  }

  const filtersToRender = (Array.isArray(dateRangeFilterList) && dateRangeFilterList.length) ? dateRangeFilterList : builtInDateRangeFilterList

  const applyRangeFilterWithTime = (sDate: Date, eDate: Date, label: string, e?: any) => {
    applyRangeFilter(sDate, eDate, e, label)
    if (enableTimePicker) {
      const fmt = (d: Date) => `${format(d, 'HH:mm:ss')}.${format(d, 'SSS')}`
      const nextFrom = fmt(new Date(sDate))
      const nextTo = fmt(new Date(eDate))
      setFromTimeInputMask(nextFrom)
      setToTimeInputMask(nextTo)
      const fErr = validateTimeField(nextFrom)
      const tErr = validateTimeField(nextTo)
      runCrossTimeValidation(nextFrom, nextTo, fErr, tErr, 'from')
    }
  }

  const filterHelpers = {
    applyRange: (sDate: Date, eDate: Date, label: string, e?: any) => applyRangeFilterWithTime(sDate, eDate, label, e),
    setLabel: (label: string) => setSelectedCalenderFilter(label)
  }

  useEffect(() => {
    if (!selectedDateRangeFilter) return
    const match = filtersToRender.find((f: any) => f?.label === selectedDateRangeFilter || f?.testId === selectedDateRangeFilter)
    if (match && typeof match.action === 'function') {
      setSelectedCalenderFilter(match.label)
      // Invoke action to set dates/time using helpers
      match.action(undefined, filterHelpers)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDateRangeFilter])

  const isCustomSelection = selectedCalenderFilter === (t('DateRangePicker.custom_date') || 'Custom Date') || selectedCalenderFilter === (t('DateRangePicker.custom_range') || 'Custom Range')
  const safeEnd = (calenderEndDate && calenderStartDate && calenderEndDate.getTime() >= calenderStartDate.getTime()) ? calenderEndDate : calenderStartDate

  return (
    <>
      <div className="DateRangePicker" data-test-id={`cs-daterange-container`}>
        <div className="DateRangePicker__main">
          {withFilters ? <div className="DateRangePicker__left__filters">
            {
              filtersToRender.map((range: any) => {
                return (<div
                  key={range.testId}
                  data-test-id={`cs-daterange-filter-${range.testId}`}
                  className={`flex-v-center ${range.label === selectedCalenderFilter ? 'calender-filter-selected' : ''}`}
                  onClick={(e: any) => {
                    // e.stopPropagation();
                    if (typeof range.action === 'function') {
                      // Pass helpers so custom actions can apply range
                      range.action(e, filterHelpers)
                    }
                  }}>{range.label}</div>)
              })
            }
          </div> : null}
          <div className="DateRangePicker__body">
            <div className="DateRangePicker__header">
              <div className={`DateRangePicker__from__input`}>
                <FieldLabel testId='cs-daterange-label-from' required htmlFor='cs-daterange-from-input' version="v2">{t('DateRangePicker.from_date') || 'From Date'}</FieldLabel>
                <InputMask
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setcurrentCalenderActive('from')
                  }}
                  disabled={false}
                  data-test-id={'cs-daterange-input-from'}
                  // mask={"99-99-9999"}
                  // maskPlaceholder={"mm-dd-yyyy"}
                  mask={getMaskValue(startDateInputMask)}
                  maskPlaceholder={' '}
                  placeholder={"mm-dd-yyyy"}
                  className={`${classname || ''} ${currentCalenderActive === 'from' ? 'DateRangePicker__input__active' : ''}` || ""}
                  value={(startDateInputMask === '  -  -    ' || startDateInputMask.trim() === '') ? '' : startDateInputMask}
                  onChange={onStartDateInputChangeHandler}
                />
              </div>
              {enableTimePicker && (
                <div className="DateRangePicker__from__time">
                  <FieldLabel testId='cs-daterange-label-from-time' htmlFor='cs-daterange-from-time-input' version="v2">{t('DateRangePicker.from_time') || 'From Time'}</FieldLabel>
                  <InputMask
                    onClick={(e: any) => {
                      e.stopPropagation()
                    }}
                    disabled={false}
                    data-test-id={'cs-daterange-input-from-time'}
                    mask={"99:99:99.999"}
                    maskPlaceholder={' '}
                    placeholder={'hh:mm:ss.ms'}
                    className={`${classname || ''}` || ""}
                    value={fromTimeInputMask}
                    onChange={onFromTimeInputChangeHandler}
                  />
                  {fromTimeError && (
                    <ValidationMessage version='v2' testId="cs-daterange-from-time-validation-error-message">{fromTimeError}</ValidationMessage>
                  )}
                </div>
              )}
              <div className="DateRangePicker__to__input">
                <FieldLabel testId='cs-daterange-label-to' required htmlFor='cs-daterange-to-input' version="v2">{t('DateRangePicker.to_date') || 'To Date'}</FieldLabel>
                <InputMask
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setcurrentCalenderActive('to')
                  }}
                  className={`${classname || ''} ${currentCalenderActive === 'to' ? 'DateRangePicker__input__active' : ''}` || ""}
                  disabled={false}
                  data-test-id={'cs-daterange-input-to'}
                  // mask={"99-99-9999"}
                  // maskPlaceholder={"mm-dd-yyyy"}
                  mask={getMaskValue(endDateInputMask)}
                  maskPlaceholder={' '}
                  placeholder={"mm-dd-yyyy"}
                  value={(endDateInputMask === '  -  -    ' || endDateInputMask.trim() === '') ? '' : endDateInputMask}
                  onChange={onEndDateInputChangeHandler}
                />
              </div>
              {enableTimePicker && (
                <div className="DateRangePicker__to__time">
                  <FieldLabel testId='cs-daterange-label-to-time' htmlFor='cs-daterange-to-time-input' version="v2">{t('DateRangePicker.to_time') || 'To Time'}</FieldLabel>
                  <InputMask
                    onClick={(e: any) => {
                      e.stopPropagation()
                    }}
                    disabled={false}
                    data-test-id={'cs-daterange-input-to-time'}
                    mask={"99:99:99.999"}
                    maskPlaceholder={' '}
                    placeholder={'hh:mm:ss.ms'}
                    className={`${classname || ''}` || ""}
                    value={toTimeInputMask}
                    onChange={onToTimeInputChangeHandler}
                  />
                  {toTimeError && (
                    <ValidationMessage version='v2' testId="cs-daterange-to-time-validation-error-message">{toTimeError}</ValidationMessage>
                  )}
                </div>
              )}
              <>{rangeHasErrorObject.has_error &&
                <ValidationMessage testId='cs-daterange-validation-error-message' className='calender__input__error flex-v-center' version='v2' >{rangeHasErrorObject.error_message || t('DateRangePicker.please_enter_valid_date') || 'Please enter valid date'}</ValidationMessage>
              }</>
            </div>
            {showCustomDateInfoBanner && customDateInfoBannerContent && isCustomSelection && (
              <div className="DateRangePicker__info-banner">
                <Info
                  version="v2"
                  type="light"
                  testId="cs-daterange-info-banner"
                  content={customDateInfoBannerContent}
                />
              </div>
            )}
            {
              currentCalenderActive === "from" && (
                <div className="DateRangePicker__from__calender">
                  <Datepicker
                    testId='cs-daterange-from-calender'
                    initialDate={calenderStartDate}
                    version='v2'
                    onChange={onStartDateCalenderChangeHandler}
                    startDate={isCustomSelection ? undefined : calenderStartDate}
                    endDate={isCustomSelection ? undefined : safeEnd}
                    formatType='mm dd yyyy'
                    inputMaskProps={maskProp}
                    withFooter={false}
                    withCurrentDate={false}
                    selectsStart
                    datePickerRestProps={{
                      // Keep range highlight regardless of constraints
                      startDate: calenderStartDate,
                      endDate: safeEnd,
                      minDate: isCustomSelection?getMinDateForCalendar(true): undefined,
                      ref: calenderRangeStart
                    }}
                    enablePropagationOnchange={true}
                  />
                </div>
              )
            }
            {
              currentCalenderActive === "to" && (
                <div className="DateRangePicker__to__calender">
                  <Datepicker
                    testId='cs-daterange-to-calender'
                    initialDate={calenderEndDate}
                    onChange={onEndDateCalenderChangeHandler}
                    startDate={isCustomSelection ? undefined : calenderStartDate}
                    endDate={isCustomSelection ? undefined : safeEnd}
                    version='v2'
                    formatType='mm dd yyyy'
                    inputMaskProps={maskProp}
                    withFooter={false}
                    withCurrentDate={false}
                    selectsEnd
                    datePickerHeadersProps={{
                      maxDate: getMaxDate(new Date()),
                      minDate: isCustomSelection? getMinDateForCalendar(false) : calenderStartDate
                    }}
                    datePickerRestProps={{
                      // Keep range highlight regardless of constraints
                      startDate: calenderStartDate,
                      endDate: safeEnd,
                      minDate: isCustomSelection? getMinDateForCalendar(false) : calenderStartDate,
                      maxDate: getMaxDate(new Date()),
                      ref: calenderRangeEnd
                    }}
                    enablePropagationOnchange={true}
                  />
                </div>
              )
            }
          </div>
        </div>
        {withFooter ? <div className="DateRangePicker__footer flex-justify">
          <Button testId={`${'cs-daterange-calender-reset'}`} buttonType="secondary" size="regular" onClick={onResetClickHandler} version="v2">
            {t('DateRangePicker.reset') || 'Reset'}
          </Button>
          <ButtonGroup>
            <Button testId={`${cancelCtaTestId ? cancelCtaTestId : 'cs-daterange-picker-cancel'}`} buttonType="tertiary" onClick={onCancelClickHandler} version="v2">
              {t('DateRangePicker.cancel') || 'Cancel'}
            </Button>
            <Button testId={`${doneCtaTestId ? doneCtaTestId : 'cs-daterange-picker-done'}`} size="regular" buttonType="primary" version='v2' onClick={onDoneClickHandler} disabled={enableTimePicker && (!!fromTimeError || !!toTimeError)} >
              {t('DateRangePicker.done') || 'Done'}
            </Button>
          </ButtonGroup>
        </div> : null}
      </div>
    </>
  )
}

function DatePickerCalendar(
  {}:{
    testId: string;
  }
) {

}